// extracted by mini-css-extract-plugin
export default {"container":"translatableText_container__7B02O","contentRow":"translatableText_contentRow__v-uL1"};